import { PrismicRichText } from "@prismicio/react";
import Styles from "./Text.module.css";
import { Button } from "@/components";

const Default = ({ primary }) => {
	return (
		<section
			className={Styles.wrapper}
			data-padding-small-top={primary?.small_padding_top}
			data-padding-small-bottom={primary?.small_padding_bottom}
		>
			<div className={Styles.container} data-contain="true">
				<PrismicRichText field={primary?.content} />
				<div className={Styles.btnContainer}>
					{primary?.cta_label && primary?.cta_link && (
						<Button link={primary?.cta_link} label={primary?.cta_label} />
					)}
					{primary?.secondary_cta_label && primary?.secondary_cta_link && (
						<Button
							variant="secondary"
							link={primary?.secondary_cta_link}
							label={primary?.secondary_cta_label}
						/>
					)}
				</div>
			</div>
		</section>
	);
};

export default Default;
